module.exports = __webpack_public_path__ + "static/img/icon-upload.e7b493a8.svg";